import { GlCard, GlLoadingIcon, GlIcon, GlIntersectionObserver, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, __ } from '~/locale';
import { designsProjectWorkItemPath } from '~/lib/utils/path_helpers/project';
import Timeago from '../../../vue_shared/components/time_ago_tooltip.vue?vue3';
import { ROUTES } from '../../constants';
export default {
    name: 'DesignItem',
    components: {
        GlCard,
        GlLoadingIcon,
        GlIntersectionObserver,
        GlIcon,
        Timeago
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        id: {
            type: [
                Number,
                String
            ],
            required: true
        },
        event: {
            type: String,
            required: true
        },
        notesCount: {
            type: Number,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        filename: {
            type: String,
            required: true
        },
        updatedAt: {
            type: String,
            required: false,
            default: null
        },
        isUploading: {
            type: Boolean,
            required: false,
            default: true
        },
        imageV432x230: {
            type: String,
            required: false,
            default: null
        },
        workItemIid: {
            type: String,
            required: false,
            default: null
        },
        useRouter: {
            type: Boolean,
            required: true
        },
        isDragging: {
            type: Boolean,
            required: false,
            default: false
        },
        workItemFullPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            imageLoading: true,
            imageError: false,
            wasInView: false
        };
    },
    computed: {
        icon () {
            const normalizedEvent = this.event.toLowerCase();
            const icons = {
                creation: {
                    name: 'file-addition-solid',
                    classes: 'gl-fill-icon-success',
                    tooltip: __('Added in this version')
                },
                modification: {
                    name: 'file-modified-solid',
                    classes: 'gl-fill-icon-info',
                    tooltip: __('Modified in this version')
                },
                deletion: {
                    name: 'file-deletion-solid',
                    classes: 'gl-fill-icon-danger',
                    tooltip: __('Archived in this version')
                }
            };
            return icons[normalizedEvent] ? icons[normalizedEvent] : {};
        },
        notesLabel () {
            return n__('%d comment', '%d comments', this.notesCount);
        },
        imageLink () {
            return this.wasInView ? this.imageV432x230 || this.image : '';
        },
        showLoadingSpinner () {
            return this.imageLoading || this.isUploading;
        },
        showImageErrorIcon () {
            return this.wasInView && this.imageError;
        },
        showImage () {
            return !this.showLoadingSpinner && !this.showImageErrorIcon;
        },
        routerLinkProps () {
            return {
                name: this.$options.ROUTES.design,
                params: {
                    iid: this.workItemIid,
                    id: this.filename
                },
                query: this.$route.query
            };
        },
        nonRouterHref () {
            return designsProjectWorkItemPath(this.workItemFullPath, {
                iid: this.workItemIid,
                vueroute: this.filename
            });
        },
        linkComponent () {
            return this.useRouter ? 'router-link' : 'a';
        }
    },
    methods: {
        onImageLoad () {
            this.imageLoading = false;
            this.imageError = false;
        },
        onImageError () {
            this.imageLoading = false;
            this.imageError = true;
        },
        onAppear () {
            // do nothing if image has previously
            // been in view
            if (this.wasInView) {
                return;
            }
            this.wasInView = true;
            this.imageLoading = true;
        },
        onTileClick (event) {
            if (this.isDragging) {
                event.preventDefault();
            }
        }
    },
    ROUTES
};
